import(/* webpackMode: "eager" */ "/Users/hezeying/mbti-web/app/components/WorkItemList/index.jsx");
import(/* webpackMode: "eager" */ "/Users/hezeying/mbti-web/app/work/[id]/page.module.scss")